import { Link } from "react-router-dom";
import { categories } from "@/mocks/data";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-camera-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-semibold text-foreground-900">
                国产自拍指南
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              汇聚国产自拍技巧、设备推荐、构图方法与后期处理全攻略，助你轻松拍出高质感自拍大片。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              更多分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-foreground-600 mb-4">
              获取最新自拍技巧和行业资讯
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                aria-label="小红书"
              >
                <i className="ri-chat-smile-2-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200/60 text-foreground-600 hover:bg-primary-100 hover:text-primary-600 transition-colors cursor-pointer"
                aria-label="B站"
              >
                <i className="ri-bilibili-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 国产自拍指南. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              使用条款
            </a>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}